import { Component } from 'react';
import {connect} from 'react-redux';
import {Col, Container, Row} from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor';
import {getArticlesAboutIgnite} from '../../actions/about-ignite';
import {loadPageContent} from '../../actions/content';
import NewsList from '../common/article/news-list';
import ArticleList from '../common/article/article-list';

class AboutIgnite extends Component {
  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  constructor(props) {
    super(props);

    this.pageSlug = 'about-ignite';
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(getArticlesAboutIgnite());
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  render() {
    const {articleList, contents, area} = this.props;

    return (
      <Container fluid className="about-ignite newslist user-inner-container">
        <Row>
          <Col className="newslist-title" lg={12}>
            <PageTitle>
              About Ignite
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              contents={contents[`${this.pageSlug}_content_text`]}
              identifier={`${this.pageSlug}_content_text`}
              onContentSaved={this.handleContentSaved}
            />
          </Col>
        </Row>
        {(area !== 'retailer' && area !== 'pre_login') && (
          <Row>
            <Col lg={12}>
              <ArticleList articles={articleList} type={area}/>
            </Col>
          </Row>
        )}
        {(area === 'retailer' || area === 'pre_login') && (
          <Row className="newslist-news">
            <Col lg={12}>
              <NewsList articles={articleList} />
            </Col>
          </Row>
        )}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  articleList: state.aboutIgnite.aboutIgniteArticles,
  fetching: state.aboutIgnite.fetching,
  fetched: state.aboutIgnite.fetched,
  contents: state.content.list
});

export default connect(mapStateToProps)(AboutIgnite);
